import {LANGUAGE_LIST} from "./const";

export const renderLanguageFamily = ({ language }) => {
    const found = LANGUAGE_LIST.find(function (element) {
        return element.id === language
    })
    return found ? found.value : ''
}

export default renderLanguageFamily



// WEBPACK FOOTER //
// ./src/modules/internationalization/renderLanguageFamily.js